<template>
  <div class="lg:col-span-7 xl:col-span-6">
    <div
      id="elements-container"
      class="flex sm:flex-wrap mt-10 lg:mt-0 mx-auto md:max-w-xl lg:max-w-full"
    >
      <div class="w-1/2 xs:w-1/3">
        <div id="element-1" class="header-element header-card mb-4 sm:mb-6">
          <div
            class="bg-white relative rounded-md p-2 mx-2 sm:mx-4 xxl:mx-6 text-center"
          >
            <div class="flex items-center absolute right-0">
              <div class="bg-white shadow-md -mt-6 rounded-md p-2 mx-1">
                <svg
                  class="h-4 text-orange-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="bg-white shadow-md -mt-6 rounded-md p-2 mx-1">
                <svg
                  class="h-4 text-blue-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                  />
                </svg>
              </div>
            </div>
            <picture>
              <source type="image/webp" srcset="../../assets/man1.webp" />
              <img
                class="mx-auto rounded-md bg-contain"
                src="../../assets/man1.jpg"
                alt="Kodulehe tegemine"
              />
            </picture>
            <div class="text-primary-black font-medium text-xs md:text-sm pt-4">
              Mark Tamm
            </div>
            <div class="text-primary-gray font-normal text-xxs pt-1 pb-4">
              Fotograaf
            </div>
          </div>
        </div>
        <div id="element-2" class="header-element header-card mt-4 sm:mt-6">
          <div class="bg-white shadow-dark rounded-md px-3 py-2 mr-2 xxl:mr-10">
            <div class="flex flex-wrap items-center">
              <div class="w-1/2">
                <div class="flex items-center">
                  <span
                    class="text-primary-black text-xl md:text-2xl font-semibold"
                    >4.4</span
                  >
                  <svg
                    class="h-4 ml-1 text-orange-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    />
                  </svg>
                </div>
                <div class="text-xxxs text-primary-gray font-normal">
                  32 arvustust
                </div>
              </div>
              <div class="w-1/2 text-xxxs">
                <div class="flex items-center">
                  <span class="text-xxxs text-primary-gray">5</span>
                  <svg
                    class="h-2 text-orange-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    />
                  </svg>
                  <span class="w-16 h-020 ml-1 bg-green-300"></span>
                </div>
                <div class="flex items-center">
                  <span class="text-xxxs text-primary-gray">4</span>
                  <svg
                    class="h-2 text-orange-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    />
                  </svg>
                  <span class="w-12 h-020 ml-1 bg-green-300"></span>
                </div>
                <div class="flex items-center">
                  <span class="text-xxxs text-primary-gray">3</span>
                  <svg
                    class="h-2 text-orange-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    />
                  </svg>
                  <span class="w-10 h-020 ml-1 bg-green-300"></span>
                </div>
                <div class="flex items-center">
                  <span class="text-xxxs text-primary-gray">2</span>
                  <svg
                    class="h-2 text-orange-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    />
                  </svg>
                  <span class="w-8 h-020 ml-1 bg-green-300"></span>
                </div>
                <div class="flex items-center pr-1">
                  <span class="text-xxxs text-primary-gray">1</span>
                  <svg
                    class="h-2 text-orange-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    />
                  </svg>
                  <span class="w-6 h-020 ml-1 bg-green-300"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="element-3"
          class="header-element header-card hidden lg:block mt-4 sm:mt-6"
        >
          <div
            class="bg-white shadow-dark rounded-md mx-2 sm:mx-4 xxl:mx-6 p-2 text-left"
          >
            <picture>
              <source type="image/webp" srcset="../../assets/hustle1.webp" />
              <img
                class="mx-auto rounded-md bg-contain h-auto"
                src="../../assets/hustle1.jpg"
                alt="Kodulehe tegemine"
              />
            </picture>
            <div class="text-primary-black font-medium text-xs md:text-sm pt-4">
              Kohvikruus
            </div>
            <div
              class="text-primary-gray text-xxs md:text-xs font-thin pt-1 pb-3 sm:pb-4"
            >
              Hustle seeria
            </div>
            <div class="flex items-center justify-between">
              <div class="text-green-300 text-xs font-medium">7.99€</div>
              <div class="bg-green-300 shadow-green p-2 rounded-md">
                <svg
                  class="h-4 text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="xs:w-1/3 hidden xs:block">
        <div id="element-4" class="header-element header-card">
          <div class="bg-white rounded-md xxl:mx-3 p-3">
            <svg
              class="mx-auto text-green-300 w-5 h-auto"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
              />
            </svg>
            <div
              class="mt-2 text-primary-black text-center text-xs md:text-sm font-semibold"
            >
              Teated
            </div>
            <div
              class="my-2 flex items-center bg-white shadow-dark rounded-md p-1 sm:p-3"
            >
              <div class="w-1/3">
                <picture>
                  <source
                    type="image/webp"
                    srcset="../../assets/jasmine1.webp"
                  />
                  <img
                    class="mx-auto rounded-md bg-contain"
                    src="../../assets/jasmine1.jpg"
                    alt="Kodulehe tegemine"
                  />
                </picture>
              </div>
              <div class="pl-2 w-2/3">
                <div class="text-primary-black font-medium text-xxs md:text-xs">
                  Anna
                </div>
                <div class="text-xxs text-pink-400 flex items-center">
                  <svg
                    class="text-pink-400 w-3 h-auto"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span class="pl-1 text-xxxs md:text-xxs">Lisas südame</span>
                </div>
              </div>
            </div>
            <div
              class="my-2 flex items-center bg-white shadow-dark rounded-md p-1 sm:p-3"
            >
              <div class="w-1/3">
                <picture>
                  <source type="image/webp" srcset="../../assets/harry1.webp" />
                  <img
                    class="mx-auto rounded-md bg-contain"
                    src="../../assets/harry1.jpg"
                    alt="Kodulehe tegemine"
                  />
                </picture>
              </div>
              <div class="w-2/3 pl-2">
                <div class="text-primary-black font-medium text-xxs md:text-xs">
                  Tom
                </div>
                <div class="text-xxs flex items-center">
                  <svg
                    class="w-2 h-auto text-green-400"
                    viewBox="0 0 120 120"
                    version="1.1"
                    fill="currentColor"
                  >
                    <circle cx="60" cy="60" r="50" />
                  </svg>
                  <span class="pl-1 text-green-400 text-xxxs md:text-xxs"
                    >Kommenteeris</span
                  >
                </div>
              </div>
            </div>
            <div
              class="my-2 flex items-center bg-white shadow-dark rounded-md p-1 sm:p-3"
            >
              <div class="w-1/3">
                <picture>
                  <source type="image/webp" srcset="../../assets/liisi1.webp" />
                  <img
                    class="mx-auto rounded-md bg-contain"
                    src="../../assets/liisi1.jpg"
                    alt="Kodulehe tegemine"
                  />
                </picture>
              </div>
              <div class="w-2/3 pl-2">
                <div class="text-primary-black font-medium text-xxs md:text-xs">
                  Liisi
                </div>
                <div class="text-xxs flex items-center">
                  <svg
                    class="w-3 h-auto text-orange-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span
                    class="pl-1 text-orange-400 whitespace-no-wrap text-xxxs md:text-xxs"
                    >Kutsub sõbraks</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="element-12" class="header-element lg:hidden mt-6 sm:mt-10">
          <div
            class="bg-white relative flex items-center p-1 rounded-md sm:mx-3"
          >
            <picture>
              <source type="image/webp" srcset="../../assets/pizza1.webp" />
              <img
                class="w-auto h-12 object-contain rounded-md"
                src="../../assets/pizza1.jpg"
                alt="Kodulehe tegemine"
              />
            </picture>
            <div class="ml-2">
              <div
                class="text-primary-black text-xxs font-medium leading-tight"
              >
                Papa
                <br />Pizzeria
              </div>
              <div class="mt-1 text-primary-gray text-xxxs">3,2km</div>
            </div>
            <div class="flex items-center absolute right-0">
              <div
                class="bg-white text-orange-300 shadow-md -mt-16 rounded-md p-2 mx-1"
              >
                <svg class="h-3" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div
                class="bg-white text-blue-400 shadow-md -mt-16 rounded-md p-2 mx-1"
              >
                <svg class="h-3" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="hidden mt-6 lg:flex">
          <div
            id="element-5"
            class="header-element header-card flex flex-col items-stretch bg-white shadow-dark rounded-md px-4 pt-6 mt-8"
          >
            <div class="flex-1">
              <svg
                class="h-5 w-5 text-green-300"
                fill="currentColor"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                />
              </svg>
            </div>
            <div class="flex-1">
              <svg
                class="h-5 w-5 opacity-50 text-green-300 hover:text-green-400 transition ease-in-out duration-150"
                fill="currentColor"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
                />
              </svg>
            </div>
            <div class="flex-1">
              <svg
                class="h-5 w-5 opacity-50 text-green-300 hover:text-green-400 transition ease-in-out duration-150"
                fill="currentColor"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                />
              </svg>
            </div>
          </div>

          <div
            id="element-6"
            class="header-element header-card rounded-md py-8 px-6 text-center bg-white mx-4 my-2"
          >
            <svg
              class="w-6 h-6 text-yellow-400 mx-auto"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                clip-rule="evenodd"
              />
            </svg>
            <div class="text-4xl font-medium text-primary-black">27</div>
            <div class="text-xs font-thin text-primary-gray">Päikseline</div>
          </div>
        </div>
      </div>
      <div class="w-1/2 xs:w-1/3">
        <div id="element-7" class="header-element header-card mb-4 sm:mb-6">
          <div
            class="bg-white flex items-center p-1 rounded-md shadow-dark mx-2"
          >
            <img
              src="../../assets/music1.jpg"
              class="w-auto h-12 rounded-md"
              alt="Kodulehe tegemine"
            />
            <div class="flex flex-wrap w-full items-center justify-between">
              <div class="ml-2">
                <div
                  class="uppercase text-primary-black text-xxxs md:text-xxs font-bold"
                >
                  Find my way
                </div>
                <div class="my-1 text-primary-gray text-xxxs">Dollaby</div>
              </div>
              <div
                class="shadow-green h-4 w-4 sm:h-6 sm:w-6 rounded-full sm:ml-auto mx-2"
              >
                <svg
                  class="h-6 w-6 sm:h-8 sm:w-8 transform -translate-y-1 -translate-x-1 text-green-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="md:mt-6 flex lg:hidden">
          <div
            id="element-10"
            class="header-element flex flex-col items-stretch bg-white shadow-dark rounded-md mx-2 px-4 pt-6 mt-8"
          >
            <div class="flex-1">
              <svg
                class="h-5 w-5 text-green-300"
                fill="currentColor"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                />
              </svg>
            </div>
            <div class="flex-1">
              <svg
                class="h-5 w-5 opacity-50 text-green-300 hover:text-green-400 transition ease-in-out duration-150"
                fill="currentColor"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
                />
              </svg>
            </div>
            <div class="flex-1">
              <svg
                class="h-5 w-5 opacity-50 text-green-300 hover:text-green-400 transition ease-in-out duration-150"
                fill="currentColor"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                />
              </svg>
            </div>
          </div>
          <div
            id="element-11"
            class="header-element rounded-md p-6 md:p-8 text-center bg-white mx-2 my-2"
          >
            <svg
              class="w-6 h-6 text-yellow-400 mx-auto"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                clip-rule="evenodd"
              />
            </svg>
            <div class="text-2xl md:text-5xl font-medium text-primary-black">
              27
            </div>
            <div class="text-xs font-thin text-primary-gray">Päikseline</div>
          </div>
        </div>
        <div
          id="element-8"
          class="header-element header-card mt-4 sm:mt-6 hidden lg:block"
        >
          <div class="bg-white rounded-md mx-2 sm:mx-4 p-3 text-center">
            <img
              class="mx-auto rounded-md w-full h-auto bg-contain"
              src="../../assets/welcome.svg"
              alt="Kodulehe tegija"
            />
            <div
              class="text-green-300 font-light text-xxs md:text-xs pt-4 uppercase"
            >
              Tere tulemast
            </div>
            <div
              class="text-primary-black text-xxs md:text-xs font-light pt-1 pb-4"
            >
              meie lehele
            </div>
            <div
              class="h-auto w-8 mx-auto p-2 bg-green-300 shadow-green rounded-md"
            >
              <svg
                class="h-4 w-4 text-white"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div
          id="element-9"
          class="header-element header-card xs:hidden lg:block mt-6 xs:mt-10"
        >
          <div
            class="bg-white shadow-dark relative flex items-center p-1 rounded-md sm:mx-3"
          >
            <img
              src="../../assets/pizza1.jpg"
              class="w-auto h-12 object-contain rounded-md"
              alt="Kodulehe tegemine"
            />
            <div class="ml-2">
              <div
                class="text-primary-black text-xxs font-medium leading-tight"
              >
                Papa
                <br />Pizzeria
              </div>
              <div class="mt-1 text-primary-gray text-xxxs">3,2km</div>
            </div>
            <div class="flex items-center absolute right-0">
              <div
                class="bg-white text-orange-300 shadow-md -mt-16 xxl:-mt-12 rounded-md p-2 mx-1"
              >
                <svg class="h-3" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div
                class="bg-white text-blue-400 shadow-md -mt-16 xxl:-mt-12 rounded-md p-2 mx-1"
              >
                <svg class="h-3" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

export default {
  name: "PageHeaderItems",
  methods: {
    animationsInit() {
      const scroller = this.$parent.$parent.$refs["scrollSections"];
      const trigger = "#elements-container";
      const bounceTlOptions = {
        scrollTrigger: {
          trigger: trigger,
          scroller: scroller,
          toggleActions: "restart pause resume pause",
        },
        defaults: {
          duration: 3,
          yoyo: true,
          repeat: -1,
          ease: "slow",
        },
      };
      ScrollTrigger.matchMedia({
        "(max-width: 499px)": function () {
          const tl = gsap.timeline({
            defaults: { autoAlpha: 1, y: 0, ease: "slow" },
          });
          tl.to("#element-1", { duration: 2 }, 1);
          tl.to("#element-7", { duration: 1 }, 1);
          tl.to("#element-10", { duration: 1.5 }, 1.5);
          tl.to("#element-11", { duration: 1.5 }, 1.5);
          tl.to("#element-9", { duration: 1 }, 2);
          tl.to("#element-2", { duration: 1 }, 2);

          tl.eventCallback("onComplete", () => {
            const bounceTl = gsap.timeline(bounceTlOptions);
            bounceTl.to("#element-1", { y: -20 });
            bounceTl.to("#element-7", { y: -10 }, 0);
            bounceTl.to("#element-10", { y: 5 }, 0);
            bounceTl.to("#element-11", { y: 10 }, 0);
            bounceTl.to("#element-9", { y: -10 }, 0);
            bounceTl.to("#element-2", { y: 10 }, 0);
          });
        },
        "(min-width: 500px) and (max-width: 1023px)": function () {
          const tl = gsap.timeline({
            defaults: { autoAlpha: 1, y: 0, ease: "slow" },
          });
          tl.to("#element-1", { duration: 1.5 }, 1);
          tl.to("#element-4", { duration: 2.5 }, 1);
          tl.to("#element-7", { duration: 1 }, 1);
          tl.to("#element-10", { duration: 1.3 }, 1.5);
          tl.to("#element-11", { duration: 1.3 }, 1.5);
          tl.to("#element-2", { duration: 1.3 }, 1.5);
          tl.to("#element-12", { duration: 1 }, 1.7);

          tl.eventCallback("onComplete", () => {
            const bounceTl = gsap.timeline(bounceTlOptions);
            bounceTl.to("#element-1", { y: -20 });
            bounceTl.to("#element-4", { y: -10 }, 0);
            bounceTl.to("#element-7", { y: 5 }, 0);
            bounceTl.to("#element-10", { y: 10 }, 0);
            bounceTl.to("#element-11", { y: -10 }, 0);
            bounceTl.to("#element-2", { y: 10 }, 0);
            bounceTl.to("#element-12", { y: -10 }, 0);
          });
        },
        "(min-width: 1024px)": function () {
          const tl = gsap.timeline({
            defaults: { autoAlpha: 1, y: 0, ease: "slow" },
          });
          tl.to("#element-1", { duration: 1.5 }, 1);
          tl.to("#element-4", { duration: 2.5 }, 1);
          tl.to("#element-7", { duration: 1 }, 1);
          tl.to("#element-8", { duration: 1 }, 1.2);
          tl.to("#element-2", { duration: 1 }, 1.4);
          tl.to("#element-3", { duration: 2 }, 1.6);
          tl.to("#element-5", { duration: 1.5 }, 1.6);
          tl.to("#element-6", { duration: 1.5 }, 1.6);
          tl.to("#element-9", { duration: 1.5 }, 1.6);

          tl.eventCallback("onComplete", () => {
            const bounceTl = gsap.timeline(bounceTlOptions);
            bounceTl.to("#element-1", { y: -20 });
            bounceTl.to("#element-4", { y: -10 }, 0);
            bounceTl.to("#element-7", { y: 5 }, 0);
            bounceTl.to("#element-8", { y: 10 }, 0);
            bounceTl.to("#element-2", { y: -10 }, 0);
            bounceTl.to("#element-3", { y: 10 }, 0);
            bounceTl.to("#element-5", { y: -10 }, 0);
            bounceTl.to("#element-6", { y: -15 }, 0);
            bounceTl.to("#element-9", { y: 5 }, 0);
          });
        },
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      gsap.set(".header-element", {
        autoAlpha: 0,
        y: -50,
      });
      this.animationsInit();
    });
  },
};
</script>

<style scoped>
</style>
